import src from "IMAGE";
export default { src, width: 769, height: 135, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAIElEQVR42mOQUGEw4hVh0GVgYNAGYnUg1gBiNSDWAdEAH5IBrxuVJxgAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
